import api from "./axios";

// Mail Gönder
export const sendMail = async (data) => {
    // data: { userId, title, body }
    // userId 0 veya null ise backend herkese gonderiyor olabilir
    try {
        const response = await api.post("api/v1/Queue/bildirim/send-mail-service", data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Mail gönderilemedi!" };
    }
};

// Bildirim Gönder (Push Notification)
export const sendNotification = async (data) => {
    try {
        const response = await api.post("api/v1/Queue/bildirim/send-notification-service", data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Bildirim gönderilemedi!" };
    }
};

// Hem Mail Hem Bildirim Gönder
export const sendBoth = async (data) => {
    try {
        const response = await api.post("api/v1/Queue/bildirim/sent-service", data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "İşlem başarısız!" };
    }
};
